import type { StatsSource } from '../sync/stats';
import { activityLine, levelComparisonLine } from './statsText';
import type { StatsViewPort } from './statsView';

export interface StatsFlowDeps {
  readonly stats: StatsSource;
  readonly view: StatsViewPort;
}

export interface StatsFlowApi {
  /** 起動直後に 1 度だけ。ゲームの初期化は待たせない。 */
  start(): Promise<void>;
  /** クリアのたびに。前回の比較行を消してから、取れた場合だけ差し込む。 */
  levelCleared(levelNumber: number, elapsedMs: number): Promise<void>;
}

export function createStatsFlow(deps: StatsFlowDeps): StatsFlowApi {
  // 前のレベルの応答が次のリザルトへ紛れ込まないよう、世代で捨てる。
  let generation = 0;

  const refreshActivity = async (): Promise<void> => {
    if (!deps.stats.enabled) return;
    deps.view.setActivity(activityLine(await deps.stats.getActivity()));
  };

  return {
    start: refreshActivity,
    levelCleared: async (levelNumber, elapsedMs) => {
      deps.view.setComparison(null);
      if (!deps.stats.enabled) return;
      const current = ++generation;
      const clearTimeMs = Math.max(0, Math.round(elapsedMs));
      const [levelStats] = await Promise.all([
        deps.stats.getLevelStats(levelNumber, clearTimeMs),
        refreshActivity(),
      ]);
      if (current !== generation) return;
      deps.view.setComparison(levelComparisonLine(levelStats));
    },
  };
}
